<template>
	<div class="e-learning-result">
		<div>
			<img :src="resultIcon" alt="wynik testu" />
		</div>
		<h2>{{ getTestResult.correct ? cms.success : cms.fail }}</h2>
		<p>Twój wynik:</p>
		<p class="points">
			<b>{{ getTestResult.points }} poprawnych odpowiedzi</b>
		</p>
		<p v-if="!getTestResult.correct">
			{{ getTestResult.pointsToPass }} to wymagane minimum
		</p>
		<div class="result-info">
			<p>{{ getTestResult.correct ? cms.successInfo : cms.failInfo }}</p>
		</div>
		<button class="btn btn-primary" @click="backToDashboard()">
			Wróć na ekran główny
		</button>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	data() {
		return {
			cms: {
				/* eslint-disable */

				success: SUCCESS_QUIZ_HEADER,
				fail: FAIL_QUIZ_HEADER,
				successInfo: SUCCESS_QUIZ_INFO,
				failInfo: FAIL_QUIZ_INFO,
			},
		};
	},
	computed: {
		...mapGetters(['getTestResult']),
		resultIcon() {
			return this.getTestResult.correct
				? 'images/statusPage/ty-success.png'
				: 'images/learning/fail.svg';
		},
	},
	methods: {
		backToDashboard() {
			this.$router.push('/Dashboard');
		},
	},
	unmounted() {
		this.$store.commit('setTestResult', '');
	},
};
</script>
